<template>
  <div class="card-container" :class="{ 'card-container-full': full }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "CardContainer",
  props: {
    // 是否占满剩余高度（用于页面主体内容）
    full: { type: Boolean, default: true }
  }
}
</script>

<style lang="less" scoped>
.card-container {
  // 对齐 App 端：白底卡片 + 顶部圆角（默认 30，App help 页用 50）
  position: relative;
  width: 100%;
  background: #fff;
  border-radius: 30px 30px 0 0;
  margin-top: -16px; // 与上方 AppBar 视觉上稍微重叠，做层次感
  padding: 30px 0 0;
  box-sizing: border-box;
  z-index: 10;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.card-container-full {
  // 全屏卡片模式
  flex: 1;
  height: auto;
}
</style>
